import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M37.1654 38.5V34.8333C37.1654 32.8884 36.3927 31.0232 35.0175 29.6479C33.6422 28.2726 31.777 27.5 29.832 27.5H15.1654C13.2204 27.5 11.3552 28.2726 9.97991 29.6479C8.60465 31.0232 7.83203 32.8884 7.83203 34.8333V38.5"
            stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22.5013 20.1667C26.5514 20.1667 29.8346 16.8834 29.8346 12.8333C29.8346 8.78325 26.5514 5.5 22.5013 5.5C18.4512 5.5 15.168 8.78325 15.168 12.8333C15.168 16.8834 18.4512 20.1667 22.5013 20.1667Z"
            stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default Icon;